/*
  shop-the-look.js
  Place in: assets/shop-the-look.js
  Loaded deferred from shop-the-look.liquid
*/

(function () {
  'use strict';

  const CARD_OFFSET = 14; // px gap between hotspot edge and card

  /* ── Find all hotspot buttons ──────────────────────────────────────── */
  document.querySelectorAll('.stl-hotspot').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var id    = btn.dataset.hotspotId;
      var card  = document.getElementById('card-' + id);
      if (!card) return;

      var isOpen = !card.hidden;

      /* Close all other cards in this look first */
      var wrap = btn.closest('.stl-image-wrap');
      closeAllCards(wrap);

      if (isOpen) return; /* toggle off */

      openCard(btn, card, wrap);
    });
  });

  /* ── Close on close-button click ──────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.stl-card__close')) {
      var card = e.target.closest('.stl-card');
      if (card) closeCard(card);
    }
  });

  /* ── Close on outside click ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.stl-hotspot') && !e.target.closest('.stl-card')) {
      document.querySelectorAll('.stl-card.is-open').forEach(closeCard);
    }
  });

  /* ── Keyboard accessibility (Escape) ───────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.stl-card.is-open').forEach(closeCard);
    }
  });

  /* ── Helper functions ──────────────────────────────────────────────── */
  function openCard(btn, card, wrap) {
    card.hidden = false;
    card.classList.add('is-open');
    positionCard(btn, card, wrap);
  }

  function closeCard(card) {
    card.hidden = true;
    card.classList.remove('is-open');
  }

  function closeAllCards(wrap) {
    var selector = '.stl-card.is-open';
    var cards = wrap.querySelectorAll(selector);
    cards.forEach(closeCard);
  }

  function positionCard(btn, card, wrap) {
    /*
      Strategy: try to show the card to the right of the hotspot.
      Flip to left if the card would overflow the image-wrap right edge.
      Flip upwards if the card would overflow the bottom.
    */
    var wrapRect = wrap.getBoundingClientRect();
    var btnRect  = btn.getBoundingClientRect();

    /* Relative positions inside wrap */
    var btnLeft = btnRect.left - wrapRect.left;
    var btnTop  = btnRect.top  - wrapRect.top;
    var btnCX   = btnLeft + btnRect.width  / 2;
    var btnCY   = btnTop  + btnRect.height / 2;

    /* Card dimensions — needs to be visible to measure */
    card.style.top  = '0';
    card.style.left = '0';
    var cardW = card.offsetWidth;
    var cardH = card.offsetHeight;

    var wrapW = wrapRect.width;
    var wrapH = wrapRect.height;

    /* Horizontal: prefer right of dot */
    var leftPos = btnCX + CARD_OFFSET + btnRect.width / 2;
    if (leftPos + cardW > wrapW - 8) {
      /* Flip to left */
      leftPos = btnCX - CARD_OFFSET - btnRect.width / 2 - cardW;
    }
    /* Clamp to wrap */
    leftPos = Math.max(8, Math.min(leftPos, wrapW - cardW - 8));

    /* Vertical: prefer bottom of dot */
    var topPos = btnCY + CARD_OFFSET + btnRect.height / 2;
    if (topPos + cardH > wrapH - 8) {
      /* Flip to top */
      topPos = btnCY - CARD_OFFSET - btnRect.height / 2 - cardH;
    }
    /* Clamp to wrap */
    topPos = Math.max(8, Math.min(topPos, wrapH - cardH - 8));

    card.style.left = leftPos + 'px';
    card.style.top  = topPos + 'px';
  }
})();